const awsConfig = {
  aws_project_region: 'us-east-1',
  aws_appsync_graphqlEndpoint:
    'https://nqqzld5pzbfk5oxoot7ahae6ly.appsync-api.us-east-1.amazonaws.com/graphql',
  aws_appsync_region: 'us-east-1',
  aws_appsync_authenticationType: 'API_KEY',
  aws_appsync_apiKey: 'da2-redgxfkxovgrpggi4yqgjbjnlm',
  aws_cognito_identity_pool_id: 'us-east-1:46adf312-f079-43cb-86a7-01a8d1221d51',
  aws_cognito_region: 'us-east-1',
  aws_user_pools_id: 'us-east-1_KHJaCrr88',
  aws_user_pools_web_client_id: '3v04sg22t8gooo9fmvieis3ctv',
  oauth: {},
  aws_cognito_username_attributes: [],
  aws_cognito_social_providers: [],
  aws_cognito_signup_attributes: ['EMAIL'],
  aws_cognito_mfa_configuration: 'OFF',
  aws_cognito_mfa_types: ['SMS'],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [],
  },
  aws_cognito_verification_mechanisms: ['EMAIL'],
  aws_user_files_s3_bucket: 'targetiva-blog-images-storage182046-staging',
  aws_user_files_s3_bucket_region: 'us-east-1',
};

export default awsConfig;
